<template>
  <div class="about">
    <h1>This is an about page</h1>
    <button class="btn btn-success">About</button>
  </div>
</template>
